import {IntermediatePart} from "../../intermediatePart";
import {METADATA} from "../../constants";
import {Shower} from "../../parts/shower";
import {ShowerTubCombo} from "../../parts/showerTubCombo";

export default class EnclosureCommon extends IntermediatePart {

  constructor(props) {
    super(props);
  }

  load(dbFeature) {
    if (!dbFeature.metaData["BathType"]) {
      dbFeature.metaData["BathType"] = [METADATA.BathtubWithEnclosures]; // remove enclosure top and bottom
    }
    return super.load(dbFeature);
  }

  disabledClick() {
    const bathParent = this.getParent();
    const comboParent = bathParent.layout.parts[ShowerTubCombo.id];
    if (comboParent.freeStandingTubActive()) {
      comboParent.replacementTub.disabled = this.disabled;
    }
    if (bathParent["bathTubBody"]) {
      bathParent["bathTubBody"].disabled = this.disabled || !bathParent["bathTubBody"].canBeEnabled(); // true or check if it can be enabled;
    }
    ["enclosureTop", "enclosureBottom"].forEach(relName => {
      if (bathParent[relName] && (bathParent[relName].partId !== this.partId)) {
        bathParent[relName].disabled = this.disabled;
      }
    })
  }

  setLayers(layout) {
    if (this.partId === "skirting_board") {
      return super.setLayers(layout);
    }
    const bathtubParent = this.getParent();
    const comboParent = bathtubParent.layout.parts[ShowerTubCombo.id];

    if ((!comboParent || !comboParent.freeStandingTubActive()) && (!bathtubParent || !bathtubParent.bathTubBody || !bathtubParent.bathTubBody.activeFeature
      || !bathtubParent.bathTubBody.activeFeature.metaData["BathType"]
      || !bathtubParent.bathTubBody.activeFeature.metaData["BathType"].includes(METADATA.BathtubWithEnclosures))) {
      super.hideLayers();
      return;
    }
    super.setLayers(layout);
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const bathtubParent = this.getParent();
    const comboParent = bathtubParent.layout.parts[ShowerTubCombo.id];

    if (!comboParent || !comboParent.freeStandingTubActive()) {
      conditions.push({
        propName: "BathType",
        propValue: bathtubParent && bathtubParent.bathTubBody && bathtubParent.bathTubBody.activeFeature
          ? bathtubParent.bathTubBody.activeFeature.metaData["BathType"]
          : METADATA.BathtubWithoutEnclosures // remove Enclosure Top
      });
    }
    if (this.partId === "skirting_board") {
      const layout = bathtubParent.layout;
      const showerParent = layout.parts[Shower.id];
      const showerSize = showerParent.showerSize();
      if (showerParent && showerSize) {
        conditions.push({
          propName: "ShowerSize",
          propValue: showerSize
        });
      }
    }
    return conditions
  }

}
